import React, { useEffect, useState } from 'react';
import { Button, Form, Modal, Spinner } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import FbUnlinkAlertIcon from '../../assets/fb-unlink-alert-icon.svg';
import { postRequestAsync } from '../../helpers/apiHandler';
import './_whatsAppModal.scss';

const UnlinkAccountModal = ({ show, onHide, onDelete, phoneNumberName, wabaId }) => {
  const { access_token } = useSelector((state) => state.auth.user);
  const [confirmId, setConfirmId] = useState('');
  const [error, setError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    if (show) {
      setConfirmId('');
      setError('');
    }
  }, [show]);

  const handleConfirmIdChange = (e) => {
    setConfirmId(e.target.value);
    if (error) {
      setError('');
    }
  };

  const validateForm = () => {
    if (confirmId !== phoneNumberName) {
      setError(`Please enter "${phoneNumberName}" to confirm`);
      return false;
    }
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (validateForm()) {
      setIsSubmitting(true);

      try {
        const response = await postRequestAsync(
          '/v2/whatsapp/delete-id-binding',
          { waba_id: wabaId },
          access_token.token
        );

        setIsSubmitting(false);

        if (response.success) {
          onDelete({
            success: true,
            message: response.message || 'WhatsApp Business API integration unlinked successfully',
          });
        } else {
          setError(response.message || 'Failed to unlink WhatsApp Business API integration');
        }
      } catch (error) {
        setIsSubmitting(false);
        setError('An error occurred while unlinking WhatsApp Business API integration');
        console.error('Delete binding error:', error);
      }
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered className="unlink-facebook-modal">
      <Modal.Header closeButton>
        <div className="d-flex flex-column">
          <img src={FbUnlinkAlertIcon} alt="Warning" className="unlink-alert-icon mb-3" />
          <Modal.Title style={{ fontSize: '16px' }}>
            Unlink Facebook Account - {phoneNumberName}
          </Modal.Title>
        </div>
      </Modal.Header>

      <Form onSubmit={handleSubmit} noValidate>
        <Modal.Body>
          <p style={{ fontSize: '13px' }}>
            Unlinking your Facebook account will remove its connection to elfoA2P Platform. You'll
            no longer be able to:
          </p>

          <ul style={{ fontSize: '13px' }}>
            <li>Send WhatsApp messages</li>
            <li>Customize templates</li>
          </ul>

          <div className="confirmation-section mb-3">
            <p className="mb-2" style={{ fontSize: '13px' }}>
              To unlink this Facebook account, enter the ID name <strong>{phoneNumberName}</strong>{' '}
              to confirm
            </p>
            <Form.Control
              type="text"
              name="confirmId"
              value={confirmId}
              onChange={handleConfirmIdChange}
              isInvalid={!!error}
              placeholder={phoneNumberName}
              className="confirmation-input"
            />
            {error && <div className="text-danger mt-2">{error}</div>}
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="outline-secondary" onClick={onHide} className="cancel-btn">
            Cancel
          </Button>
          <Button variant="danger" type="submit" className="unlink-btn" disabled={isSubmitting}>
            {isSubmitting ? (
              <>
                <Spinner animation="border" size="sm" className="me-2" />
                Unlinking...
              </>
            ) : (
              'Unlink'
            )}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default UnlinkAccountModal;
